import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { AssessmentMethodEnum, TableExtendedRiskRegister } from "src/app/models/risk-assessment.model";
import { RiskRegisterCardSlotKey } from "src/app/models/risk-register-card.model";
import { RISK_REGISTER_CARD_SLOT_LABELS } from "src/app/shared/constants/riskRegisterCardSlot.constants";
import nameOf from "src/app/shared/form/nameOf.helper";
import { RiskRegisterCapabilityProfile } from "../risk-register-capability-profile";

@Component({
    standalone: false,
    selector: "app-risk-register-matrix-cell",
    templateUrl: "./risk-register-matrix-cell.component.html",
    styleUrl: "./risk-register-matrix-cell.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskRegisterMatrixCellComponent implements OnChanges {
    @Input({ required: true }) register!: TableExtendedRiskRegister;
    @Input({ required: true }) profile!: RiskRegisterCapabilityProfile;
    @Input() selected = false;
    @Input() bulkMode = false;
    @Input() isParentAssessmentApproved = false;
    @Input() canEdit = false;
    @Input() bulkLoading = false;
    @Input() designMode = false;
    @Input() designSlots: RiskRegisterCardSlotKey[] = [];
    @Input() highlightSlot: RiskRegisterCardSlotKey | null = null;
    @Input() hoverSlot: RiskRegisterCardSlotKey | null = null;
    @Output() selectedChange = new EventEmitter<boolean>();
    @Output() edit = new EventEmitter<void>();
    @Output() slotPick = new EventEmitter<RiskRegisterCardSlotKey>();
    @Output() slotHover = new EventEmitter<RiskRegisterCardSlotKey | null>();

    readonly assessmentMethodEnum = AssessmentMethodEnum;
    readonly slotLabels = RISK_REGISTER_CARD_SLOT_LABELS;
    hotspots: Partial<Record<RiskRegisterCardSlotKey, boolean>> = {};

    ngOnChanges(changes: SimpleChanges): void {
        if (changes[nameOf<RiskRegisterMatrixCellComponent>((x) => x.designSlots)]) {
            this.hotspots = Object.fromEntries(this.designSlots.map((key) => [key, true]));
        }
    }

    onCheckboxChange(event: Event): void {
        if (event.target instanceof HTMLInputElement) {
            this.selectedChange.emit(event.target.checked);
        }
    }

    onSlotClick(key: RiskRegisterCardSlotKey, event: MouseEvent): void {
        event.stopPropagation();
        this.slotPick.emit(key);
    }

    onEditClick(): void {
        if (this.canEdit && !this.isParentAssessmentApproved && !this.bulkLoading) {
            this.edit.emit();
        }
    }
}
